import * as React from 'react';

/**
 * @return {React.ReactElement}
 * @constructor
 */
export default function RoundPlus(): React.ReactElement {
  return (
    <svg width="18" height="19" viewBox="0 0 18 19" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M9 18.4805C13.9706 18.4805 18 14.451 18 9.48047C18 4.50991 13.9706 0.480469 9 0.480469C4.02944 0.480469 0 4.50991 0 9.48047C0 14.451 4.02944 18.4805 9 18.4805ZM9.75054 4.2334V8.7334H14.251V10.2334H9.75054V14.7334H8.25054V10.2334H3.75096V8.7334H8.25054V4.2334H9.75054Z" />
    </svg>
  );
}
